import { Route } from '@angular/router';
import { IndexPage } from 'app/modules/daily-activity-tracker/pages/index/index.page';
import { ActivityPage } from 'app/modules/daily-activity-tracker/pages/activity/activity.page';

export const datDashboardRoutes: Route[] = [
    {
        path: 'daily-activity-tracker',
        children: [],
    },
];

export const datDataManagementRoutes: Route[] = [
    {
        path: 'daily-activity-tracker',
        component: IndexPage,
    },
    {
        path: 'daily-activity-tracker/activity',
        component: ActivityPage,
    },
];

export const datConfigurationRoutes: Route[] = [
    {
        path: 'daily-activity-tracker',
        children: [],
    },
];
